const BASE_API = (process.env.REACT_APP_BASE_API || '').replace(/\/+$/, '');

/* "abc.png" -> BASE/uploads/abc.png (same rule as the rest of the site) */
export const toImageUrl = (src) => {
    if (!src) return '';
    if (/^(https?:)?\/\//.test(src) || src.startsWith('data:')) return src;
    const clean = String(src).replace(/^\/+/, '');
    return clean.includes('/') ? `${BASE_API}/${clean}` : `${BASE_API}/uploads/${clean}`;
};

export const formatDate = (value) =>
    value ? new Date(value).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '';

/* fetch with the login token. Always returns { ok, status, data } (data is the JSON body).
   If the token is expired (401) the user is sent to the login page. */
export const apiFetch = async (path, { method = 'GET', body } = {}) => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${BASE_API}${path}`, {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));

    if (res.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
    }
    return { ok: res.ok, status: res.status, data };
};
